import { Client as Styletron } from "styletron-engine-atomic"
import { createTheme, lightThemePrimitives } from "baseui"

const white = "#FFFFFF"
const black = "#000000"
const silver = "#CCCCCC"

const dustyGray = "#333333" // body text
const saunionsRed = "#ff0a14" // accent

export const palette = {
  white: white,
  black: black,
  primary: saunionsRed,
  secondary: dustyGray,
  tertiary: silver
}

export const engine = new Styletron({ prefix: "join-" })

const mainTypography = {
  color: dustyGray,
  fontWeight: 500,
  fontSize: "18px"
}

const headerTypography = {
  color: saunionsRed,
  fontWeight: 900,
  fontSize: "25px"
}

export const theme = createTheme(
  {
    ...lightThemePrimitives,
    primaryFontFamily: "sans-serif"
  },
  {
    colors: {
      buttonSecondaryFill: white,
      buttonSecondaryText: black,
      buttonSecondarySelectedFill: saunionsRed,
      buttonSecondarySelectedText: white,
      buttonPrimaryFill: saunionsRed,
      inputFill: white,
      tickFill: white,
      tickFillActive: silver,
      tickFillHover: silver,
      tickFillSelected: saunionsRed,
      tickFillSelectedHover: saunionsRed,
      tickFillSelectedHoverActive: saunionsRed,
      inputBorder: dustyGray
    },
    borders: {
      inputBorderRadius: "5px"
    },
    typography: {
      ParagraphXSmall: mainTypography,
      ParagraphSmall: mainTypography,
      ParagraphMedium: mainTypography,
      ParagraphLarge: mainTypography,
      LabelXSmall: mainTypography,
      LabelSmall: mainTypography,
      LabelMedium: mainTypography,
      LabelLarge: mainTypography,
      font950: headerTypography
    }
  }
)
